import React, { useState, useEffect } from 'react';
import {
  Paper,
  Grid,
  Button,
  Divider,
  IconButton,
  Tooltip,
  CircularProgress,
  Box
} from '@mui/material';
import ReportProblemOutlined from '@mui/icons-material/ReportProblemOutlined';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import Edit from '@mui/icons-material/Edit';
import { Typography } from '../../../components/Generic/StyledComponent';
import ProfileCard from './components/profileCard';
import HospitalDetails from './components/hospitalDetails';
import BankDetails from './components/bankDetails';
import FamilyDetails from './components/patientFamilyDetails';
import HorizontalScroll from './components/horizontalScroll';
import LabelValue from './components/labelValue';
import ActionModal from './components/actionModal';
import SettledModal from './components/settledModal/Index';
import ApproveModal from './components/approveModal';
import ReferDocModal from './components/referDocModal';
import RectificationModal from './components/rectificationModal';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import {
  useGetClaimDetails,
  usePostClaimAction,
  useGetSlabDetails,
  useGetInProgressClaim
} from './hooks';
import FetchView from 'src/components/common/fetchView';
import { toast } from 'react-toastify';
import useMobileDetect from 'src/useMobileDetect';
import { useHistory } from 'react-router-dom';
import { USER_ROLES } from 'src/constants';
import { MutualAid } from 'src/services/api';
import ClaimList from 'src/containers/PatientList/ClaimList';
import SlabDetails from './components/slabDetails';
import ReconcileModal from './components/reconcileModal';
import {
  fetchClaimInformation,
  fetchNewClaimStatuses,
  fetchReviewerRoles,
  getDowngradeRequestHistory,
  getEligibleReviewersApi,
  postActionReconcile,
  raiseClaimStatusDowngradeRequest
} from 'src/redux/action/claimService';
import SplitPane from 'react-split-pane';
import useCredentials from 'src/hooks/useCredentials';
import PdfViewer from 'src/components/common/pdfViewer/PdfViewer';
import DocumentModal from './components/documentModal';
import Loader from 'src/components/Generic/Loader';
import ZoomInMapOutlinedIcon from '@mui/icons-material/ZoomInMapOutlined';
import ZoomOutMapOutlinedIcon from '@mui/icons-material/ZoomOutMapOutlined';
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import SettlementHistory from './SettlementHistory';
import SwapMemberModal from './components/swapMemberModal';
import CommentSection from './components/commentSection';
import SelectLable from './components/selectLabel';
import RejectionBucketDetails from './components/rejectionBucketDetails';
import StatusDowngradeModal from '../claimList/components/StatusDowngradeModal';
import { toTitleCase } from 'src/containers/Reimbursements/common/data';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DowngradeRequestHistory from 'src/containers/Reimbursements/ReimbursementsDetails/sections/downgradeRequestHistory/DowngradeRequestHistory';
import {
  fetchRefreshRules,
  fetchRiskDetails
} from 'src/redux/action/ewsService';
import { RISK_BUTTON_COLOR } from 'src/utils';
import EWS from '../ews';

export const hasRole = (role) => {
  let userRoles = localStorage.getItem('user_roles');
  if (userRoles) {
    userRoles = JSON.parse(userRoles);
    const obj = userRoles.find((o) => o.role_name === role);

    if (obj && Object.keys(obj).length > 0) {
      return true;
    }
  }
  return false;
};

export const newHasRole = (roles = []) => {
  let userRoles = localStorage.getItem('user_roles');

  if (!userRoles) return false;
  try {
    userRoles = JSON.parse(userRoles);

    const normalizedUserRoles = userRoles.map((ur) =>
      ur.role_name?.toLowerCase()
    );
    const normalizedRequiredRoles = roles.map((r) => r.toLowerCase());

    return normalizedRequiredRoles.length === 0
      ? true
      : normalizedRequiredRoles.some((role) =>
        normalizedUserRoles.includes(role)
      );
  } catch (error) {
    console.error('Error parsing user_roles:', error);
    return false;
  }
};

const areSectionsApproved = (sections, { ACCOUNT, IDENTITY, Supporting }) => {
  let docStatus = false;
  let supportingDocStatus = false;
  let identityStatus = false;

  const sectionsApproved = Object.keys(sections).some(
    (sectionKey) => !sections[sectionKey]
  );
  ACCOUNT &&
    ACCOUNT.some((doc) => {
      if (doc?.status !== 'APPROVE') {
        docStatus = true;
      }
    });
  Supporting &&
    Supporting.some((doc) => {
      if (doc?.status !== 'APPROVE') {
        supportingDocStatus = true;
      }
    });
  IDENTITY &&
    IDENTITY.some((doc) => {
      if (doc?.status !== 'APPROVE') {
        identityStatus = true;
      }
    });
  return sectionsApproved || docStatus || supportingDocStatus || identityStatus;
};

function ClaimDetails({ editable }) {
  const [isApproveOpen, toggleApproveModal] = useState(false);
  const [isRejectOpen, toggleRejectModal] = useState(false);
  const [isRectificationOpen, toggleRectificationModal] = useState(false);
  const [isSettledOpen, toggleSettledModal] = useState(false);
  const [isReferModalOpen, toggleReferModal] = useState(false);
  const [isSwapModalOpen, toggleSwapModal] = useState(false);
  const [open, setOpen] = useState(false);
  const { accessToken } = useCredentials();
  const [splitScreenDoc, setSplitScreenDoc] = useState(null);
  const [shimmerLoader, setShimmerLoader] = useState(false);
  const [documentData, setDocumentData] = useState(null);
  const [splitScreen, setSplitScreen] = useState(false);
  const [isDocumentModalOpen, toggleDocumentModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [pane1Width, setPane1Width] = useState(null);
  const [diagnosticsList, setDiagonsticsList] = useState([]);
  const [category, setCategory] = useState({
    id: '',
    name: '',
    days: ''
  });

  const isDoctor = hasRole(USER_ROLES.DOC_Reviewer);
  const isIO = hasRole(USER_ROLES.IO_Reviewer);
  const isFO = hasRole(USER_ROLES.FO_Reviewer);

  const [approvedSections, updateApprovedSections] = useState({
    hospDetails: false,
    bankDetails: isDoctor ? true : false,
    hospitalizationReason: false,
    finalClaimAmount: false,
    diagnosticsOption: false
  });

  const [isReload, setIsReload] = useState(false);
  const [isApprovedBtnPressed, updateApprovedBtn] = useState(false);
  const [openReconcile, setOpenReconcile] = useState(false);
  const [swamMembers, setSwapMembers] = useState([]);
  const history = useHistory();
  const [updateDateLoading, setUpdateDateLoading] = useState(false);

  const [statusChangeOpen, setStatusChangeOpen] = useState(false);
  const [statusChangeLoading, setStatusChangeLoading] = useState(null);
  const [claimInfo, setClaimInfo] = useState(null);
  const [claimNewStatus, setClaimNewStatus] = useState([]);
  const [reviewerRoles, setReviewerRoles] = useState([]);
  const [claimStatusData, setClaimStatusData] = useState({
    movableStatus: '',
    reviewer: '',
    remarks: ''
  });
  const [downgradeRequestLoading, setDowngradeRequestLoading] = useState(false);

  const isEditable =
    ((history.location.state?.filters?.status != 'SETTELED' ||
      history.location.state != 'SETTLED') &&
      (history.location.state?.filters?.status != 'Approved' ||
        history.location.state != 'Approved') &&
      (history.location.state?.filters?.status != 'REJECTED' ||
        history.location.state != 'REJECTED')) ||
    ((history.location.state?.filters?.status === 'RECONCILE_ONE' ||
      history.location.state?.filters?.status === 'ALL') &&
      (hasRole(USER_ROLES.Claim_Manager_Reviewer) ||
        hasRole(USER_ROLES.Higher_Level_Reviewer))) ||
    editable;
  const { claimId, subClaimId } = history?.location?.state;
  const showButton =
    history?.location?.state?.showButton !== undefined
      ? history.location.state?.showButton
      : true;

  const { state, request, update } = useGetClaimDetails();
  const slabDetails = useGetSlabDetails();
  const getInProgressClaim = useGetInProgressClaim();
  const policyId = state.data?.claimDetails?.policyActualId;
  const productId = state?.data?.claimDetails?.productId;
  const [eligibleReviewers, setEligibleReviewers] = useState([]);
  const [downgradeLoading, setDowngradeLoading] = useState(false);
  const [requestData, setRequestData] = useState({});
  const [riskLevelDetails, setRiskLevelDetails] = useState(null);
  const [openRiskModal, setOpenRiskModal] = useState(false);
  const [isRefreshLoading, setIsRefreshLoading] = useState(false);

  const [BUTTON_LIST_DOC, setBUTTON_LIST_DOC] = useState([
    { icon: <PeopleAltIcon />, color: null, label: 'Refer specialist' },
    { icon: <CloseIcon />, color: '#f44336', label: 'Reject' },
    {
      icon: <ReportProblemOutlined />,
      color: 'rgba(236, 176, 45, 1)',
      label: 'Rectification'
    },
    { icon: <CheckIcon />, color: 'rgba(76, 175, 80, 1)', label: 'Approve' }
  ]);
  const [BUTTON_LIST, setBUTTON_LIST] = useState([
    { icon: <CloseIcon />, color: '#f44336', label: 'Reject' },
    {
      icon: <ReportProblemOutlined />,
      color: 'rgba(236, 176, 45, 1)',
      label: 'Rectification'
    },
    { icon: <CheckIcon />, color: 'rgba(76, 175, 80, 1)', label: 'Approve' }
  ]);
  const { state: claimActionState, request: reviewClaim } = usePostClaimAction({
    onFail: (errorObject) => {
      toast.error(errorObject.message);
    },
    onSuccess: ({ apiResponse, data }) => {
      if (apiResponse?.code === 200) {
        toast.success('successfully submitted');
      } else {
        toast.error(apiResponse?.message);
      }

      history.push({
        pathname: '/reimbursement',
        state: hasRole(USER_ROLES.IO_Reviewer)
      });
    }
  });
  useEffect(() => {
    window.scrollTo(0, 0);
    const status = state?.data?.claimDetails?.status;

    if (status !== undefined) {
      if (status === 'FO_APPROVED' && hasRole(USER_ROLES.FO_Reviewer)) {
        setBUTTON_LIST([
          { icon: <Edit />, color: 'rgb(0, 139, 197)', label: 'Settle' }
        ]);
      }

      // else if (hasRole(USER_ROLES.FO_Reviewer)) {
      //   setBUTTON_LIST(BUTTON_LIST => [...BUTTON_LIST, { icon: <Edit />, color: 'rgb(0, 139, 197)', label: 'Setteled' }])
      // }
      else if (history.location.state?.filters?.status === 'Approved') {
        setBUTTON_LIST([]);
      }
      if (
        history.location.state?.filters?.status === 'Approved' &&
        hasRole(USER_ROLES.DOC_Reviewer)
      ) {
        setBUTTON_LIST_DOC([]);
      }
      if (
        state?.data?.claimDetails &&
        (hasRole(USER_ROLES.Claim_Manager_Reviewer) ||
          hasRole(USER_ROLES.Higher_Level_Reviewer))
      ) {
        if (
          (status == 'REVIEWER_LEVEL_ONE_INP' &&
            hasRole(USER_ROLES.Claim_Manager_Reviewer)) ||
          (status == 'REVIEWER_LEVEL_TWO_INP' &&
            hasRole(USER_ROLES.Higher_Level_Reviewer))
        ) {
          setBUTTON_LIST([
            { icon: <CloseIcon />, color: '#f44336', label: 'Reject' },
            {
              icon: <ReportProblemOutlined />,
              color: 'rgba(236, 176, 45, 1)',
              label: 'Rectification'
            },
            {
              icon: <CheckIcon />,
              color: 'rgba(76, 175, 80, 1)',
              label: 'Approve'
            }
          ]);
        } else {
          setBUTTON_LIST([]);
        }
      }
    }
  }, [USER_ROLES, state?.data]);

  function btnOnPressHandler(btnType) {
    switch (btnType) {
      case 'Approve':
        updateApprovedBtn(true);
        if (areSectionsApproved(approvedSections, state.data?.documents)) {
          toast.error('Approve required sections first');
        } else {
          toggleApproveModal(true);
        }
        break;
      case 'Reject':
        toggleRejectModal(true);
        break;
      case 'Rectification':
        toggleRectificationModal(true);
        break;
      case 'Refer specialist':
        toggleReferModal(true);
        break;
      case 'swap_member':
        toggleSwapModal(true);
        break;
      case 'Settle':
        updateApprovedBtn(true);
        if (areSectionsApproved(approvedSections, state.data?.documents)) {
          toast.error('Approve required sections first');
        } else {
          toggleSettledModal(true);
        }
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    request({ claimId, subClaimId });
  }, [claimId, request, subClaimId]);

  useEffect(() => {
    getEligibleReviewers();
  }, []);

  const getEligibleReviewers = async () => {
    if (hasRole(USER_ROLES.IO_Reviewer)) {
      const response = await getEligibleReviewersApi(claimId, subClaimId);
      if (response) {
        setEligibleReviewers(response);
      }
    }
  };

  useEffect(() => {
    if (policyId) {
      slabDetails.request({ claimId, subClaimId });
      getInProgressClaim.request({ claimId, subClaimId });
    }
  }, [policyId]);

  useEffect(() => {
    if (isReload) {
      request({ claimId, subClaimId });
      setTimeout(() => {
        setIsReload(false);
      }, 300);
    }
  }, [isReload]);

  const getRiskList = async (claimId, subClaimId) => {
    if (!claimId && !subClaimId) return;
    const response = await fetchRiskDetails(claimId, subClaimId);
    setRiskLevelDetails(response);
  };

  useEffect(() => {
    getRiskList(claimId, subClaimId);
  }, []);

  const { isMobile } = useMobileDetect();
  const btnLst = hasRole(USER_ROLES.DOC_Reviewer)
    ? BUTTON_LIST_DOC
    : BUTTON_LIST;

  const handleSubmitClaimDate = (data) => {
    setUpdateDateLoading(true);
    const newData = {
      ...data,
      claimId: claimId,
      subClaimId: subClaimId,
      policyActualId: policyId
    };
    MutualAid.updateClaimDateDetails(newData)
      .then((res) => {
        if (res?.code === 200) {
          setIsReload(true);
          setCategory({
            id: '',
            name: '',
            days: ''
          });
          setOpen(false);
        }
      })
      .finally(() => {
        setOpen(false);
        setUpdateDateLoading(false);
      });
  };

  const handleSubmitReconcile = async () => {
    const res = await postActionReconcile(claimId, subClaimId);
    if (res.code == 200) {
      setIsReload(true);
      setOpenReconcile(false);
    }
  };

  const handleOpenInNew = async (document) => {
    if (!isMobile()) {
      setShimmerLoader(true);
      setSplitScreen(true);

      try {
        const res = await MutualAid.viewDocument({
          accessToken,
          data: { docId: document.id }
        });

        const blobUrl = res?.data?.blobUrl;
        const mimeType = res?.data?.mimeType;
        const arrayBuffer = res?.data?.arrayBuffer;

        if (blobUrl && mimeType) {
          setDocumentData({ blobUrl, mimeType, arrayBuffer });
          setSplitScreenDoc(document);
        }
      } catch (error) {
        console.error('Error fetching document:', error);
        setShimmerLoader(false);
      } finally {
        setShimmerLoader(false);
      }
    } else {
      setSelectedDocument(document);
      toggleDocumentModal(true);
    }
  };

  const swapMemberApi = async (selectedMember) => {
    try {
      const data = {
        claimId: claimId,
        swapMemberId: selectedMember?.id,
        subClaimId: subClaimId
      };
      const response = await MutualAid.getClaimSwap({
        accessToken,
        data
      });
      if (response?.code === 200) {
        toast.success('Swaping member successfully');
        request({ claimId, subClaimId });
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      toast.error(error?.message);
    }
  };
  const getSwapMemberListApi = async () => {
    try {
      const data = {
        claimId: claimId,
        subClaimId: subClaimId
      };
      const response = await MutualAid.getClaimSwapMemeberList({
        accessToken,
        data
      });
      if (response?.code === 200) {
        setSwapMembers(response?.data);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      toast.error(error?.message);
    }
  };
  const handleZoomIn = () => {
    if (zoomLevel < 1.3) {
      setZoomLevel(zoomLevel + 0.1);
    }
  };

  const handleZoomOut = () => {
    if (zoomLevel > 1) {
      setZoomLevel(zoomLevel - 0.1);
    }
  };

  const HandleResetTransform = () => {
    setZoomLevel(1);
  };

  const handlePaneResize = (size) => {
    setPane1Width(size);

    if (parseInt(size) > 500) {
      setZoomLevel(1);
    }
  };

  const scaleHandler = () => {
    return splitScreenDoc && zoomLevel * (splitScreenDoc && 0.93);
  };

  const handleSettleClaim = (formData) => {
    let data = {};
    if (formData.claimSettlementType === 'PARTIAL_SETTLE') {
      data = {
        amount: formData.amount,
        paymentMode: formData.paymentMode,
        transactionNumber: formData.transactionNumber,
        settlementType: formData.paymentRemarks,
        transactionDate: formData.transactionDate,
        claimSettlementType: formData.claimSettlementType
      };
    } else {
      if (formData.settlementType) delete formData.settlementType;
      data = formData;
    }
    MutualAid.settledPayment({
      accessToken,
      ...data,
      claimId,
      subClaimId,
      policyId,
      productId
    }).then((res) => {
      if (res.code === 200) {
        history.push({
          pathname: '/reimbursement',
          state: 'FO_Reviewer'
        });
      }
      toggleSettledModal(false);
    });
  };

  const isShowComment = (details) => {
    if (!details) return;
    const { status, raisedTicket } = details;
    if (
      (status?.toUpperCase() === 'IO_REJECTED' ||
        status?.toUpperCase() === 'FO_REJECTED' ||
        status?.toUpperCase() === 'DOC_REJECTED' ||
        status?.toUpperCase() === 'PARTIAL_SETTLE') &&
      raisedTicket === '1'
    )
      return true;
    return false;
  };
  async function getDiagnosticsListData() {
    try {
      const response = await MutualAid.getDiagnosticsList({
        accessToken
      });
      if (response?.code === 200) {
        setDiagonsticsList(response?.data);
        getDiagnosticsListValue();
      } else {
      }
    } catch (error) { }
  }
  async function getDiagnosticsListValue() {
    const data = {
      claimId: claimId,
      subClaimId: subClaimId
    };
    try {
      const response = await MutualAid.getDiagnosticsValue({
        accessToken,
        data
      });
      if (response?.code === 200) {
        if (response?.data) {
          const { category, categoryId, numberOfDays } = response.data;
          if (category && categoryId && numberOfDays) {
            updateApprovedSections((prevState) => ({
              ...prevState,
              diagnosticsOption: true
            }));
          }
          setCategory({
            id: categoryId,
            name: category,
            days: numberOfDays
          });
        }
      } else {
      }
    } catch (error) { }
  }

  const getReviewerRoles = async () => {
    const response = await fetchReviewerRoles();
    try {
      const formattedData = response?.map((role) => {
        return {
          label: role.label,
          value: role.value
        };
      });

      setReviewerRoles([...formattedData]);
    } catch (error) {
      console.log(error, 'error');
    }
  };

  const getNewClaimStatus = async () => {
    const response = await fetchNewClaimStatuses();
    if (response) {
      const formattedData = response?.map((role) => {
        return {
          label: toTitleCase(role?.replace(/_/g, ' ')),
          value: role
        };
      });
      setClaimNewStatus(formattedData);
    }
  };

  const getClaimDetails = async (claimId, subClaimId) => {
    if (!claimId && !subClaimId) return;
    const response = await fetchClaimInformation(claimId, subClaimId);
    if (response) {
      setClaimInfo(response);
    }
  };

  const initiateStatusDowngrade = (claimId, subClaimId) => {
    if (!claimId && !subClaimId) return;
    setStatusChangeLoading(claimId);
    getClaimDetails(claimId, subClaimId);
    getNewClaimStatus();
    getReviewerRoles();
    setStatusChangeLoading(null);
    setStatusChangeOpen(true);
  };

  const getDowngradeRequestData = () => {
    if (claimId && subClaimId) {
      setDowngradeLoading(true);
      getDowngradeRequestHistory(claimId, subClaimId).then((res) => {
        setRequestData(res);
      });
      setDowngradeLoading(false);
    }
  };

  const refresh = () => {
    request({ claimId, subClaimId });
    getDowngradeRequestData();
  };

  const submitDowngradeRequest = async (claimId, subClaimId) => {
    if (!claimId && !subClaimId) return;
    setDowngradeRequestLoading(true);
    let payload = {
      claimId: claimId,
      subClaimId: subClaimId,
      currentStatus: claimInfo?.status,
      claimRegisterDate: claimInfo?.claimDate,
      memberName: claimInfo?.memberName,
      mobileNumber: claimInfo?.mobileNumber,
      resellerIds: [claimInfo?.resellerId],
      resellerName: claimInfo?.resellerName,
      loanCode: claimInfo?.loanCode,
      claimAmount: claimInfo?.claimAmount || 0,
      claimApprovedAmount: claimInfo?.claimApprovedAmount || 0,
      movableStatus: claimStatusData?.movableStatus,
      reviewer: claimStatusData?.reviewer,
      remarks: claimStatusData?.remarks
    };

    const response = await raiseClaimStatusDowngradeRequest(payload);
    if (response) {
      toast.success(response?.message);
      if (response?.code == 200) {
        setStatusChangeOpen(false);
        setClaimStatusData({
          movableStatus: '',
          reviewer: '',
          remarks: ''
        });
      }
      refresh();
    }
    setDowngradeRequestLoading(false);
  };

  const showDowngradeButton = (status) => {
    const allowedStatuses = [
      //   'SETTLED',
      //   'SETTELED',
      'IO_REJECTED',
      'DOC_REJECTED',
      'FO_REJECTED',
      'REJECTED',
      'REVIEWER_LEVEL_ONE_REJECT',
      'REVIEWER_LEVEL_TWO_REJECT',
      'APPROVED',
      'IO_APPROVED',
      'DOC_APPROVED',
      'FO_APPROVED',
      'Approved',
      'REVIEWER_LEVEL_ONE_APPROVED',
      'REVIEWER_LEVEL_TWO_APPROVED',
      'CANCELLED'
    ];

    if (allowedStatuses.includes(status)) {
      return true;
    } else {
      return false;
    }
  };

  const handleRefresh = async (claimId, subClaimId) => {
    if (!claimId && !subClaimId) return;
    setIsRefreshLoading(true);
    try {
      const response = await fetchRefreshRules(claimId, subClaimId);
      await request({ claimId, subClaimId });
    } catch (error) {
      console.error('Refresh failed:', error);
    } finally {
      setIsRefreshLoading(false);
    }
  };

  React.useEffect(() => {
    getDiagnosticsListData();
  }, []);

  useEffect(() => {
    if (hasRole(USER_ROLES.IO_Reviewer)) {
      getSwapMemberListApi();
    }
  }, []);

  React.useEffect(() => {
    getDowngradeRequestData();
  }, []);

  const claimStatus = state?.data?.claimDetails?.status;
  const showEwsRefButton = state?.data?.claimDetails?.showEwsRefButton === true;
  const isIOorFOInProcess =
    claimStatus === 'IO_IN_PROCESS' || claimStatus === 'FO_IN_PROCESS';
  const isRefreshEnabled = isIOorFOInProcess && showEwsRefButton;
  const disableOtherActions = isRefreshEnabled;

  return (
    <>
      <Grid
        container
        style={{ marginTop: 5, padding: isMobile() ? '' : '5px' }}
      >
        <FetchView {...state} hasData={!!Object.keys(state.data).length}>
          <Grid
            container
            style={{
              display: 'flex',
              flexDirection: 'row'
            }}
          >
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                alignItems: { xs: 'stretch', sm: 'center' },
                gap: 1,
                mb: 1
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: { xs: 'center', sm: 'flex-start' }
                }}
              >
                {hasRole(USER_ROLES.RISK_ASSESSMENT) &&
                  state.data?.claimDetails?.ewsRiskLevel && (
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: 10 }}
                    >
                      <p
                        style={{
                          cursor: 'pointer',
                          color: 'rgb(0 8 255)',
                          padding: 1
                        }}
                        onClick={() => setOpenRiskModal(true)}
                      >
                        Risk Assessment
                      </p>
                      –
                      <img
                        alt=""
                        style={{ height: 70, width: 70, marginLeft: 8 }}
                        src={
                          RISK_BUTTON_COLOR[
                            state.data?.claimDetails?.ewsRiskLevel
                          ]?.icon || ''
                        }
                      />
                    </div>
                  )}
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: { xs: 'center', sm: 'flex-end' },
                  alignItems: 'center',
                  gap: { xs: 1, sm: 1.5 }
                }}
              >
                {hasRole(USER_ROLES.CLAIM_STATUS_MODIFIER) &&
                  showDowngradeButton(state.data?.claimDetails?.status) && (
                    <Box
                      sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
                    >
                      <Button
                        variant="contained"
                        disabled={
                          state.data?.claimDetails?.submittedToStatusReviewer
                        }
                        onClick={() =>
                          initiateStatusDowngrade(claimId, subClaimId)
                        }
                        sx={{
                          backgroundColor: state.data?.claimDetails
                            ?.submittedToStatusReviewer
                            ? 'grey.300'
                            : '#DB2228',
                          color: state.data?.claimDetails
                            ?.submittedToStatusReviewer
                            ? 'black'
                            : 'white',
                          height: 32,
                          fontSize: { xs: '0.7rem', sm: '0.85rem' },
                          px: 1.5,
                          '&:hover': {
                            backgroundColor: '#c11c21'
                          }
                        }}
                      >
                        {statusChangeLoading === claimId ? (
                          <CircularProgress size={18} color="inherit" />
                        ) : (
                          'Raise Transition Request'
                        )}
                      </Button>

                      {state.data?.claimDetails?.submittedToStatusReviewer && (
                        <Tooltip title="Request pending review">
                          <InfoOutlinedIcon
                            fontSize="small"
                            sx={{ cursor: 'pointer', color: 'grey.500' }}
                          />
                        </Tooltip>
                      )}
                    </Box>
                  )}
                <Button
                  variant="contained"
                  onClick={() => handleRefresh(claimId, subClaimId)}
                  disabled={!isRefreshEnabled || isRefreshLoading}
                  startIcon={
                    isRefreshLoading ? (
                      <CircularProgress
                        size={16}
                        sx={{
                          color: '#fff'
                        }}
                      />
                    ) : (
                      <RestartAltOutlinedIcon />
                    )
                  }
                  sx={{
                    cursor: 'pointer',
                    height: 32,
                    fontSize: { xs: '0.7rem', sm: '0.85rem' },
                    textTransform: 'capitalize',
                    backgroundColor: '#f44336',
                    color: '#fff',
                    '&:hover': {
                      backgroundColor: '#c11c21'
                    },
                    '&.Mui-disabled': isRefreshLoading
                      ? {
                        backgroundColor: '#c11c21',
                        color: '#fff',
                        opacity: 1,
                        cursor: 'not-allowed'
                      }
                      : {}
                  }}
                >
                  Refresh
                </Button>
                {isEditable &&
                  showButton &&
                  btnLst?.map((btn) => (
                    <Button
                      key={btn.label}
                      variant="contained"
                      startIcon={btn.icon}
                      disabled={disableOtherActions}
                      onClick={() => btnOnPressHandler(btn.label)}
                      sx={{
                        textTransform: 'capitalize',
                        backgroundColor: btn.color,
                        fontSize: { xs: '0.7rem', sm: '0.85rem' },
                        height: 32,
                        px: 1.5
                      }}
                    >
                      {btn.label}
                    </Button>
                  ))}
              </Box>
            </Box>
          </Grid>

          <Divider
            style={{
              width: '100%',
              marginBottom: 24
            }}
          />

          <Grid container>
            <SplitPane
              split={'vertical'}
              minSize={250}
              maxSize={900}
              style={{ position: 'relative', columnGap: '5px' }}
              defaultSize={!isMobile() && splitScreen ? '50%' : '100%'}
              size={!isMobile() && splitScreen ? '50%' : '100%'}
              resizerStyle={{ width: '1px' }}
              onChange={handlePaneResize}
            >
              <Grid
                container
                style={{
                  overflowY: !isMobile() && splitScreen ? 'scroll' : '',
                  maxHeight: !isMobile() && splitScreen ? '72vh' : ''
                }}
              >
                <Grid
                  item
                  sm={12}
                  md={splitScreen ? 12 : 3}
                  style={{
                    paddingRight: splitScreen ? 0 : isMobile() ? 0 : 10,
                    width: isMobile() ? '100%' : '',
                    marginBottom: splitScreen ? '20px' : ''
                  }}
                >
                  <ProfileCard
                    data={state.data.patientDetails}
                    productName={state.data?.claimDetails?.comboProductName}
                    productId={state.data?.claimDetails?.productId}
                    claimDetails={state.data?.claimDetails}
                    handleSubmitClaimDate={handleSubmitClaimDate}
                    open={open}
                    setOpen={setOpen}
                    btnOnPressHandler={(label) => btnOnPressHandler(label)}
                    loading={updateDateLoading}
                    isShowButton={
                      history.location.state === 'IN_PROGRESS' ||
                        history?.location?.state?.filters?.status ===
                        'IN_PROGRESS'
                        ? true
                        : false
                    }
                  />
                  <HospitalDetails
                    data={state.data}
                    isApproved={approvedSections.hospDetails}
                    isEditable={isEditable}
                    canEdit={hasRole(USER_ROLES.IO_Reviewer)}
                    isApprovedBtnPressed={isApprovedBtnPressed}
                    setIsReload={setIsReload}
                    toggleApproved={() =>
                      updateApprovedSections((prevState) => ({
                        ...prevState,
                        hospDetails: !prevState.hospDetails
                      }))
                    }
                  />
                  <BankDetails
                    style={{ marginTop: isMobile() ? 0 : 10 }}
                    karzaData={state.data.karzaResponseDto}
                    data={state.data.claimDetails}
                    isApproved={
                      approvedSections.bankDetails ||
                      hasRole(USER_ROLES.DOC_Reviewer)
                    }
                    isEditable={isEditable}
                    isApprovedBtnPressed={isApprovedBtnPressed}
                    setIsReload={setIsReload}
                    toggleApproved={() =>
                      updateApprovedSections((prevState) => ({
                        ...prevState,
                        bankDetails: !prevState.bankDetails
                      }))
                    }
                    isVerifryButtonShow={
                      hasRole(USER_ROLES.FO_Reviewer) &&
                      history.location.state?.filters?.status === 'Approved'
                    }
                    pennyDropOverride={state.data.pennyDropOverride}
                  />
                  <FamilyDetails
                    style={{ marginTop: isMobile() ? 0 : 10 }}
                    data={state.data?.patientFamilyDetails}
                    allData={state.data}
                  />
                  {(state?.data?.claimDetails?.rejectionCategory ||
                    state.data?.claimDetails?.rectificationCategory) && (
                      <RejectionBucketDetails
                        style={{ marginTop: isMobile() ? 0 : 10 }}
                        data={state.data?.claimDetails}
                      />
                    )}
                </Grid>
                <Grid
                  item
                  sm={12}
                  md={splitScreen ? 12 : 9}
                  style={{
                    width: isMobile() ? '100%' : '',
                    marginTop: isMobile() ? '20px' : '',
                    paddingRight: splitScreen ? 0 : isMobile() ? 0 : 10
                  }}
                >
                  <SlabDetails
                    slabData={slabDetails?.state?.data}
                    inProgressClaim={getInProgressClaim?.state?.data}
                    splitScreenDoc={splitScreenDoc}
                  />
                  <br />
                  {state.data?.claimDetails?.remarks && (
                    <Paper
                      style={{
                        padding: 16,
                        borderColor: 'rgba(30, 103, 133, 1)',
                        marginBottom: 24
                      }}
                      variant="outlined"
                    >
                      <Typography
                        color="rgba(30, 103, 133, 1)"
                        variant="subtitle1"
                      >
                        Reimbursement Officer Remark:
                      </Typography>
                      <Typography
                        color="rgba(20, 20, 20, 1)"
                        variant="subtitle2"
                      >
                        {state.data?.claimDetails?.remarks}
                      </Typography>
                    </Paper>
                  )}
                  <Paper
                    style={{ padding: 16, marginBottom: 24 }}
                    variant="outlined"
                  >
                    <Typography
                      color="rgba(30, 103, 133, 1)"
                      variant="subtitle1"
                    >
                      Reimbursement
                    </Typography>
                    <div
                      style={{
                        marginTop: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        flexDirection: isMobile() ? 'column' : 'row'
                      }}
                    >
                      <div
                        style={{
                          width: isMobile() ? '100%' : '50%'
                        }}
                      >
                        <LabelValue
                          editable={
                            isEditable &&
                            (hasRole(USER_ROLES.IO_Reviewer) ||
                              hasRole(USER_ROLES.DOC_Reviewer))
                          }
                          values={{
                            claimId,
                            subClaimId
                          }}
                          field={'reason'}
                          request={MutualAid.updateClaimReason}
                          setIsReload={setIsReload}
                          label="Reason for Hospitalization"
                          value={state.data?.claimDetails?.reason}
                          labelColor={
                            isApprovedBtnPressed &&
                            !approvedSections.hospitalizationReason &&
                            'red'
                          }
                          icon={() => {
                            if (isEditable) {
                              return (
                                <IconButton
                                  style={{ padding: 5 }}
                                  onClick={() =>
                                    updateApprovedSections((prevState) => ({
                                      ...prevState,
                                      hospitalizationReason:
                                        !prevState.hospitalizationReason
                                    }))
                                  }
                                  size="large"
                                >
                                  {approvedSections.hospitalizationReason ? (
                                    <CheckCircleIcon
                                      style={{ color: 'rgba(33, 150, 83, 1)' }}
                                    />
                                  ) : (
                                    <CheckCircleOutlineOutlinedIcon
                                      style={{
                                        color: isApprovedBtnPressed
                                          ? 'red'
                                          : null
                                      }}
                                    />
                                  )}
                                </IconButton>
                              );
                            } else {
                              return null;
                            }
                          }}
                        />
                      </div>
                      <div
                        style={{
                          width: isMobile() ? '100%' : '50%',
                          paddingTop: '20px'
                        }}
                      >
                        <SelectLable
                          disabled={
                            history.location.state?.filters?.status ===
                            'SETTELED' ||
                            history.location.state === 'SETTELED' ||
                            history.location.state?.filters?.status ===
                            'Approved' ||
                            history.location.state === 'Approved'
                          }
                          diagnosticsList={diagnosticsList}
                          onChange={(e) => {
                            let value = e?.target?.value;
                            const selectedCategory = diagnosticsList.find(
                              (item) => item?.id === value
                            );
                            setCategory({
                              id: selectedCategory?.id,
                              name: selectedCategory?.category,
                              days: selectedCategory?.days
                            });

                            updateApprovedSections((prevState) => ({
                              ...prevState,
                              diagnosticsOption: true
                            }));
                          }}
                          value={category?.id}
                          name="diagnostics-value"
                          labelColor={
                            isApprovedBtnPressed &&
                            !approvedSections.diagnosticsOption &&
                            'red'
                          }
                          error={
                            isApprovedBtnPressed &&
                            !approvedSections.diagnosticsOption &&
                            'Required'
                          }
                        />
                      </div>
                    </div>
                    <div style={{ marginTop: '20px' }}>
                      <LabelValue
                        editable={isEditable && hasRole(USER_ROLES.IO_Reviewer)}
                        values={{
                          claimId,
                          subClaimId
                        }}
                        field={'amount'}
                        request={MutualAid.updateSubClaimAmount}
                        setIsReload={setIsReload}
                        label="Reimbursement Amount"
                        value={state.data?.claimDetails?.amount?.requested}
                        valuePreSymbol="₹"
                        labelColor={
                          isApprovedBtnPressed &&
                          !approvedSections.finalClaimAmount &&
                          'red'
                        }
                        icon={() => {
                          if (isEditable) {
                            return (
                              <IconButton
                                // disabled={
                                //   hasRole(USER_ROLES.DOC_Reviewer) ||
                                //   hasRole(USER_ROLES.FO_Reviewer)
                                // }
                                style={{ padding: 5 }}
                                onClick={() =>
                                  updateApprovedSections((prevState) => ({
                                    ...prevState,
                                    finalClaimAmount:
                                      !prevState.finalClaimAmount
                                  }))
                                }
                                size="large"
                              >
                                {approvedSections.finalClaimAmount ? (
                                  <CheckCircleIcon
                                    style={{ color: 'rgba(33, 150, 83, 1)' }}
                                  />
                                ) : (
                                  <CheckCircleOutlineOutlinedIcon
                                    style={{
                                      color: isApprovedBtnPressed ? 'red' : null
                                    }}
                                  />
                                )}
                              </IconButton>
                            );
                          } else {
                            return null;
                          }
                        }}
                      />
                    </div>
                    {state.data?.claimDetails?.amount?.approved && (
                      <LabelValue
                        label="Final Approved Amount"
                        value={`₹ ${state.data?.claimDetails?.amount?.approved}`}
                      />
                    )}
                  </Paper>

                  <Paper
                    style={{ padding: 16, marginBottom: 24 }}
                    variant="outlined"
                  >
                    <Typography
                      variant="subtitle1"
                      style={{ marginBottom: 16 }}
                    >
                      Medical Documents
                    </Typography>
                    {state.data?.documents?.IDENTITY ? (
                      <HorizontalScroll
                        label="Identity"
                        items={state.data?.documents?.IDENTITY}
                        onDocApprove={update}
                        isApprovedBtnPressed={isApprovedBtnPressed}
                        isEditable={isEditable}
                        onOpenInNew={handleOpenInNew}
                      // isApproved={isFO}
                      />
                    ) : null}
                    {state.data?.documents?.ACCOUNT ? (
                      <HorizontalScroll
                        label="Account"
                        items={state.data?.documents?.ACCOUNT}
                        onDocApprove={update}
                        isApprovedBtnPressed={isApprovedBtnPressed}
                        isEditable={isEditable}
                        onOpenInNew={handleOpenInNew}
                      // isApproved={isFO}
                      />
                    ) : null}
                    {state.data?.documents?.Supporting ||
                      hasRole(USER_ROLES.IO_Reviewer) ? (
                      <HorizontalScroll
                        label="Supporting"
                        items={state.data?.documents?.Supporting}
                        onDocApprove={update}
                        claimId={state.data?.claimDetails?.claimId}
                        isApprovedBtnPressed={isApprovedBtnPressed}
                        isEditable={isEditable}
                        setIsReload={setIsReload}
                        IO_Reviewer={hasRole(USER_ROLES.IO_Reviewer)}
                        reseller_id={state.data?.claimDetails?.resellerId}
                        onOpenInNew={handleOpenInNew}
                      // isApproved={isFO}
                      />
                    ) : null}
                  </Paper>

                  <Paper
                    style={{
                      padding: 16,
                      marginBottom: !isMobile() && splitScreen ? '0' : 24
                    }}
                    variant="outlined"
                  >
                    <Typography
                      color="rgba(30, 103, 133, 1)"
                      variant="subtitle1"
                    >
                      Reimbursement List
                    </Typography>
                    <ClaimList
                      insuredMemberId={
                        state.data.patientDetails?.insuredMemberId || ''
                      }
                    />
                  </Paper>

                  <Paper
                    style={{ padding: 16, marginBottom: 24 }}
                    variant="outlined"
                  >
                    <Typography
                      color="rgba(30, 103, 133, 1)"
                      variant="subtitle1"
                    >
                      Settlement History
                    </Typography>
                    <SettlementHistory
                      claimId={claimId}
                      subClaimId={subClaimId}
                    />
                  </Paper>
                  <Paper
                    style={{ padding: 16, marginBottom: 24 }}
                    variant="outlined"
                  >
                    <Typography
                      color="rgba(30, 103, 133, 1)"
                      variant="subtitle1"
                    >
                      Status Transition Request History
                    </Typography>
                    <DowngradeRequestHistory
                      requestData={requestData}
                      loading={downgradeLoading}
                    />
                  </Paper>
                  {isShowComment(state?.data?.claimDetails) && (
                    <Paper
                      style={{ padding: 16, marginBottom: 24 }}
                      variant="outlined"
                    >
                      <Typography
                        color="rgba(30, 103, 133, 1)"
                        variant="subtitle1"
                      >
                        Comments section
                      </Typography>
                      <CommentSection
                        claimId={claimId}
                        subClaimId={subClaimId}
                      />
                    </Paper>
                  )}
                </Grid>
              </Grid>

              {shimmerLoader ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: 'calc(90vh - 105px)'
                  }}
                >
                  <Loader />
                </div>
              ) : (
                !isMobile() &&
                splitScreen && (
                  <div
                    style={{
                      display: 'flex',
                      maxHeight: !isMobile() && splitScreen ? '72vh' : ''
                    }}
                  >
                    {documentData &&
                      (documentData.mimeType === 'application/pdf' ? (
                        <>
                          {parseInt(pane1Width) < 450 && (
                            <div
                              style={{
                                position: 'absolute',
                                zIndex: 1,
                                left: '0px'
                              }}
                            >
                              <Tooltip title="Zoom In">
                                <IconButton
                                  onClick={handleZoomIn}
                                  disabled={zoomLevel >= 1.3}
                                  style={{ marginRight: '2px' }}
                                >
                                  <ZoomInMapOutlinedIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Zoom Out">
                                <IconButton
                                  onClick={handleZoomOut}
                                  disabled={zoomLevel <= 1}
                                  style={{ marginRight: '2px' }}
                                >
                                  <ZoomOutMapOutlinedIcon />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title="Reset Transform">
                                <IconButton
                                  onClick={() => HandleResetTransform()}
                                  style={{ marginRight: '2px' }}
                                >
                                  <RestartAltOutlinedIcon />
                                </IconButton>
                              </Tooltip>
                            </div>
                          )}

                          {!isMobile() && splitScreen && (
                            <div
                              style={{
                                position: 'absolute',
                                zIndex: 1,
                                right: '14px'
                              }}
                            >
                              <Tooltip title="Close Split Screen">
                                <IconButton
                                  onClick={() => {
                                    setDocumentData(null);
                                    setSplitScreenDoc(null);
                                    setSplitScreen(false);
                                    setPane1Width(null);
                                    setZoomLevel(1);
                                  }}
                                >
                                  <CloseOutlinedIcon />
                                </IconButton>
                              </Tooltip>
                            </div>
                          )}

                          <PdfViewer
                            // zoomLevel={zoomLevel}
                            scaleHandler={scaleHandler}
                            splitScreenDoc={splitScreenDoc}
                            pdf={{ data: documentData.arrayBuffer }}
                            onClose={() => {
                              setDocumentData(null);
                              setSplitScreenDoc(null);
                              setSplitScreen(false);
                              setPane1Width(null);
                              setZoomLevel(1);
                            }}
                          />
                        </>
                      ) : (
                        <>
                          {!isMobile() && splitScreen && (
                            <div
                              style={{
                                position: 'absolute',
                                zIndex: 1,
                                right: '14px'
                              }}
                            >
                              <Tooltip title="Close Split Screen">
                                <IconButton
                                  onClick={() => {
                                    setDocumentData(null);
                                    setSplitScreenDoc(null);
                                    setSplitScreen(false);
                                    setPane1Width(null);
                                    setZoomLevel(1);
                                  }}
                                >
                                  <CloseOutlinedIcon />
                                </IconButton>
                              </Tooltip>
                            </div>
                          )}
                          <img
                            src={documentData.blobUrl}
                            alt="document-preview"
                            style={{
                              width: '100%',
                              height: 'calc(89vh - 105px)',
                              objectFit: 'contain'
                            }}
                          />
                        </>
                      ))}
                  </div>
                )
              )}

              {isMobile() && isDocumentModalOpen && (
                <DocumentModal
                  open={isDocumentModalOpen}
                  handleClose={() => {
                    toggleDocumentModal(false);
                    setSelectedDocument(null);
                  }}
                  selectedDocument={selectedDocument}
                />
              )}
            </SplitPane>
          </Grid>
        </FetchView>
      </Grid>
      <ApproveModal
        claimId={claimId}
        subClaimId={subClaimId}
        role={hasRole(USER_ROLES.IO_Reviewer)}
        open={isApproveOpen}
        handleClose={() => toggleApproveModal(false)}
        apiLoading={claimActionState.loading}
        amount={state.data?.claimDetails?.amount || 0}
        onSuccessPress={(form) => {
          reviewClaim({
            status: 'APPROVE',
            ...form,
            claimId,
            subClaimId,
            productId,
            policyId,
            days: category.days,
            category: category.name,
            categoryId: category.id
          });
        }}
        approveClaimNotify={state.data?.claimDetails?.approveClaimNotify}
        isDoctor={isDoctor}
        isIO={isIO}
        isFO={isFO}
        slabData={slabDetails?.state?.data}
        claimDetails={state.data?.claimDetails}
        category={category}
        eligibleReviewers={eligibleReviewers}
      />
      <ActionModal
        headerLabel="Reject"
        open={isRejectOpen}
        handleClose={() => toggleRejectModal(false)}
        apiLoading={claimActionState.loading}
        onSuccessPress={(form) =>
          reviewClaim({
            status: 'REJECT',
            ...form,
            claimId,
            subClaimId
            // referee: 'FO_Reviewer'
          })
        }
        rejectionCategory={state?.data?.rejectionCategory}
      />
      <ReferDocModal
        open={isReferModalOpen}
        handleClose={() => toggleReferModal(false)}
        apiLoading={claimActionState.loading}
        onSuccessPress={(form) =>
          reviewClaim({
            status: 'REFER',
            ...form,
            claimId,
            subClaimId
            // referee: 'FO_Reviewer'
          })
        }
      />
      <SwapMemberModal
        open={isSwapModalOpen}
        handleClose={() => toggleSwapModal(false)}
        patientDetails={state?.data?.patientDetails}
        familyDetails={swamMembers}
        allData={state.data}
        onSuccessPress={(selectedMember) => swapMemberApi(selectedMember)}
      />

      <RectificationModal
        open={isRectificationOpen}
        handleClose={() => toggleRectificationModal(false)}
        apiLoading={claimActionState.loading}
        onSuccessPress={(form) =>
          reviewClaim({
            status: 'RESUBMIT',
            ...form,
            claimId,
            subClaimId
            // referee: 'FO_Reviewer'
          })
        }
        resubmitOfficers={state.data?.resubmitOfficers}
        rectificationCategory={state?.data?.rectificationCategory}
      />
      <SettledModal
        open={isSettledOpen}
        handleClose={() => toggleSettledModal(false)}
        apiLoading={claimActionState.loading}
        onSuccessPress={handleSettleClaim}
        resubmitOfficers={state.data?.resubmitOfficers}
        claimDetails={state.data?.claimDetails}
      />

      <ReconcileModal
        open={openReconcile}
        handleClose={() => setOpenReconcile(false)}
        handleConfirm={() => {
          handleSubmitReconcile();
        }}
      />
      <StatusDowngradeModal
        open={statusChangeOpen}
        onClose={() => {
          setStatusChangeOpen(false);
          setClaimStatusData({
            movableStatus: '',
            reviewer: '',
            remarks: ''
          });
        }}
        loading={statusChangeLoading}
        formData={claimStatusData}
        setFormData={setClaimStatusData}
        claimInfo={claimInfo}
        claimNewStatus={claimNewStatus}
        reviewerRoles={reviewerRoles}
        finalLoading={downgradeRequestLoading}
        handleStatusDowngrade={(claimId, subClaimId) => {
          submitDowngradeRequest(claimId, subClaimId);
        }}
      />

      <EWS
        claimId={claimId}
        ewsRiskLevel={riskLevelDetails?.riskLevel}
        open={openRiskModal}
        riskLevelDetails={riskLevelDetails?.riskLevelDetailsDto}
        setOpen={setOpenRiskModal}
        subClaimId={subClaimId}
        highRiskRules={riskLevelDetails?.highRiskRules}
        totalRules={riskLevelDetails?.totalRules}
      />
    </>
  );
}
export default ClaimDetails;
